import { SectionType } from "./section.model";

export class AddSectionDTO {
    name: string | undefined;
    type: SectionType | undefined;
    order: number | undefined;
    data: any;
}